import { render, staticRenderFns } from "./HighlightTextarea.vue?vue&type=template&id=678725c6&scoped=true&"
import script from "./HighlightTextarea.vue?vue&type=script&lang=js&"
export * from "./HighlightTextarea.vue?vue&type=script&lang=js&"
import style0 from "./HighlightTextarea.vue?vue&type=style&index=0&id=678725c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678725c6",
  null
  
)

export default component.exports